module.exports = __webpack_public_path__ + "img/john-f.-kennedy.a52b7418.png";